import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as agendaActions } from "reducers/contactDestination";
import { actions as accountsActions } from "reducers/accounts";

export const useListContacts = ({ loadDetail = false }) => {
    const dispatch = useDispatch();
    const { id = "" } = useParams();
    const { accounts, fetching: fetchingAccounts } = useSelector((state) => state.accounts);
    const {
        listFrequentDestinations,
        moreDestinations,
        fetching: fetchingContact,
        pageNumber,
        totalPages,
        frequentDestination: selectedContact,
    } = useSelector((state) => state.contactDestination);

    const findContact = () => {
        if (id && loadDetail === true) {
            dispatch(agendaActions.loadDetailRequest(id));
        }
    };

    useEffect(() => {
        // if (listFrequentDestinations?.length === 0) {
        dispatch(agendaActions.loadListRequest());
        // }
    }, []);

    useEffect(() => {
        if (listFrequentDestinations.length) {
            findContact();
        }
    }, [listFrequentDestinations]);

    useEffect(() => {
        if (accounts?.length === 0) {
            dispatch(accountsActions.listAccounts());
        }
    }, [dispatch]);

    return {
        selectedContact,
        listFrequentDestinations,
        moreDestinations,
        fetching: fetchingAccounts || fetchingContact,
        dispatch,
        pageNumber,
        totalPages,
    };
};

export default useListContacts;
